import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';
import { useTrendProjection } from '@/hooks/useTrendProjection';
import { ReportProps } from '../common.props';
import { formatNumber } from '@/lib/currency.utils';

export function TrendProjectionPanel({ displayCurrency, convert }: ReportProps) {
  const { data, isLoading } = useTrendProjection();
  // const formattedProjectedMonthEnd = formatNumber(convert(data.projectedMonthEnd, row.currency, displayCurrency));
  // const formattedProjectedYearEnd = formatNumber(convert(data.projectedYearEnd, row.currency, displayCurrency));
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Spending Trend Projection</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && <p className="text-sm text-muted-foreground">Loading...</p>}

        {!isLoading && data?.hasInsufficientData && (
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              Insufficient data for a reliable projection. At least 3 days of transactions are needed.
            </AlertDescription>
          </Alert>
        )}

        {!isLoading && data && !data.hasInsufficientData && (
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <p className="text-sm text-muted-foreground">Projected Month-End</p>
              <p className="text-2xl font-semibold">{formatNumber(data.projectedMonthEnd)}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm text-muted-foreground">Projected Year-End</p>
              <p className="text-2xl font-semibold">{formatNumber(data.projectedYearEnd)}</p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
